import { memo, useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIn } from '../../utils/getIn';
import { getFullUrlWithCurrentSubDomain } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getUserPreferencesUrl = () => `${getFullUrlWithCurrentSubDomain()}/settings/${PortalIdParser.get()}/user-preferences/calling`;
const CurrentSettingsInfoHelpDesk = ({
  selectedCallProvider,
  onCallButtonClick
}) => {
  const providerName = useMemo(() => getIn(['name'], selectedCallProvider), [selectedCallProvider]);
  const onChangeProviderClick = useCallback(() => {
    onCallButtonClick();
  }, [onCallButtonClick]);
  return selectedCallProvider ? /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      paddingInline: "400",
      paddingBlock: "300",
      "data-selenium-test": "selected-third-party-help-desk-provider",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "body-300",
        children: providerName
      }), /*#__PURE__*/_jsx(Link, {
        external: true,
        href: getUserPreferencesUrl(),
        onClick: onChangeProviderClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "thirdPartyHelpDeskPopover.changeCallingProvider"
        })
      })]
    })
  }) : null;
};
export default /*#__PURE__*/memo(CurrentSettingsInfoHelpDesk);